module.exports = __webpack_public_path__ + "static/media/budjetme.685452fb.md";